import { render, staticRenderFns } from "./LiquidGlassEffect.vue?vue&type=template&id=2c72d9d8&scoped=true"
import script from "./LiquidGlassEffect.vue?vue&type=script&lang=js"
export * from "./LiquidGlassEffect.vue?vue&type=script&lang=js"
import style0 from "./LiquidGlassEffect.vue?vue&type=style&index=0&id=2c72d9d8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c72d9d8",
  null
  
)

export default component.exports